var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyboardArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2875 11.8043L15.4075 15.6843L11.5275 11.8043C11.1375 11.4143 10.5075 11.4143 10.1175 11.8043C9.7275 12.1943 9.7275 12.8243 10.1175 13.2143L14.7075 17.8043C14.8943 17.9916 15.148 18.0968 15.4125 18.0968C15.677 18.0968 15.9307 17.9916 16.1175 17.8043L20.7075 13.2143C21.0975 12.8243 21.0975 12.1943 20.7075 11.8043C20.3175 11.4243 19.6775 11.4143 19.2875 11.8043Z",
    fill: "#C3CAD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowDown);
export default __webpack_public_path__ + "static/media/keyboard_arrow_down.6c82b0a0677e2d18b2b4951d9bb13cf5.svg";
export { ForwardRef as ReactComponent };